import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filters'
})
export class FiltersPipe implements PipeTransform {

  transform(allRooms:any[], searchText: any[]): any {
  	return allRooms.filter( it => {
  		if(searchText != null && searchText != undefined && searchText && searchText.hasOwnProperty('product_type') && searchText.hasOwnProperty('bed_code_name')&& searchText.hasOwnProperty('viewType')){
  			// When all conditions are true start
  			if(searchText['product_type'] != null && searchText['product_type'] != undefined &&searchText['product_type'] != undefined && searchText['bed_code_name'] != null && searchText['bed_code_name'] != '' &&searchText['bed_code_name'] != undefined && searchText['viewType'] != null && searchText['viewType'] != undefined &&searchText['viewType'] != ''){
	  			if(it['product_type'].toLowerCase().includes(searchText['product_type'].toLowerCase())){
	  					// When bed_code_name filter exits start
	      				searchText['bed_code_name']=searchText['bed_code_name'].toLowerCase();
	      				if(it['bed_code_name'] !=null && it['bed_code_name'] !=''){
	      					if(it['bed_code_name'].toLowerCase().includes(searchText['bed_code_name'])){
	      						// When viewType filter exits start
										if(it['room_view_code_name'] !=null && it['room_view_code_name'] !=''){
			      					if(it['room_view_code_name'].toLowerCase().includes(searchText['viewType'])){
												return true;
											} else {
												return false;
											}
			      				} else {
			      					return false;
			      				}
			      				// When viewType filter exits end

									} else {
										return false;
									}
	      				} else {
	      					return false;
	      				}
							// When bed_code_name filter exits end

	  			} else {
	  				return false;
	  			}
  			}
  			// When all conditions are true End

  			//When only one condition exist between bed_code_name and viewType start
  			else if((searchText['product_type'] != null && searchText['product_type'] != undefined &&searchText['product_type'] != undefined && ((searchText['bed_code_name'] != null && searchText['bed_code_name'] != '' &&searchText['bed_code_name'] != undefined )|| (searchText['viewType'] != null && searchText['viewType'] != undefined &&searchText['viewType'] != ''))) || (searchText['product_type'] != null && searchText['product_type'] != undefined &&searchText['product_type'] != undefined) ){
	  			if(it['product_type'].toLowerCase().includes(searchText['product_type'].toLowerCase())){
	  					// When bed_code_name filter exits start
	      				if(searchText['bed_code_name'] != null && searchText['bed_code_name'] != '' &&searchText['bed_code_name'] != undefined ){
		      				searchText['bed_code_name']=searchText['bed_code_name'].toLowerCase();
		      				if(it['bed_code_name'] !=null && it['bed_code_name'] !=''){
		      					if(it['bed_code_name'].toLowerCase().includes(searchText['bed_code_name'])){
		      						return true;
										} else {
											return false;
										}
		      				} else {
		      					return false;
		      				}
	      				}
							// When bed_code_name filter exits end

							// When viewType filter exits start
	      				else if(searchText['viewType'] != null && searchText['viewType'] != '' &&searchText['viewType'] != undefined ){
		      				searchText['viewType']=searchText['viewType'].toLowerCase();
		      				if(it['room_view_code_name'] !=null && it['room_view_code_name'] !=''){
		      					if(it['room_view_code_name'].toLowerCase().includes(searchText['viewType'])){
		      						return true;
										} else {
											return false;
										}
		      				} else {
		      					return false;
		      				}
	      				} else {
	      					return true;
	      				}
							// When viewType filter exits end

	  			} else {
	  				return false;
	  			}
  			} else {
  				return true;
  			}

  		} else if(searchText != null && searchText != undefined && searchText && searchText.hasOwnProperty('cart_type')){
  			if(it['cart_type'].toLowerCase().includes(searchText['cart_type'].toLowerCase())){
  				return true;
  			} else {
  				return false;
  			}
  		} else {
  			return true;
  		}
    });
  }

}
